import React, { useState } from "react";
import CertificateList from "./CertificateList";
import ComplianceChecklist from "./ComplianceChecklist";
import ComplianceChecklistConfig from "./ComplianceChecklistConfig/ComplianceChecklistConfig";

const ComplianceSafetyDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<
    "certificates" | "checklists" | "configuration"
  >("certificates");

  return (
    <div className="px-2 py-4 w-full h-full mt-10">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">
          Compliance & Safety
        </h1>
        <p className="text-gray-600">
          Manage regulatory certificates and compliance checklists for utility
          systems.
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => setActiveTab("certificates")}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              ${
                activeTab === "certificates"
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }
            `}
          >
            Regulatory Certificates
          </button>
          {/*           <button
            onClick={() => setActiveTab('checklists')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              ${activeTab === 'checklists' 
                ? 'border-blue-500 text-blue-600' 
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
            `}
          >
            Compliance Checklists
          </button>
           <button
            onClick={() => setActiveTab('configuration')}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              ${activeTab === 'configuration' 
                ? 'border-blue-500 text-blue-600' 
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
            `}
          >
            Configuration
          </button> */}
        </nav>
      </div>

      {/* Content */}
      <div className="min-h-[400px]">
        {activeTab === "certificates" && <CertificateList />}
        {/*         {activeTab === 'checklists' && <ComplianceChecklist />}
        {activeTab === 'configuration' && <ComplianceChecklistConfig />} */}
      </div>
    </div>
  );
};

export default ComplianceSafetyDashboard;
